/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import { numberFormat } from 'helper';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../actions';
import * as c from '../constants';

function CreateModal({
  officialReceiptList,
  createInput,
  createOfficialReceipt,
  formData,
  setFormData,
  getOfficialReceipts,
  creating,
  triggerParentEffect,
  moduleType,
}) {
  const allFees = _.flatMap(officialReceiptList, 'fees');
  const [formDataFees, setFormDataFees] = useState({
    orFees: [],
  });
  let feesItems = JSON.parse(localStorage.getItem('feesItems'));

  if (moduleType === 'BPLS') {
    feesItems = feesItems.filter((feeItem) => {
      const [name, amount, year] = feeItem.value.split('|').map((item) => item.trim());
      return !allFees.some((allFee) => allFee.name === name && allFee.year === year);
    });
  }

  if (moduleType !== 'BPLS') {
    feesItems = feesItems.filter((feeItem) => {
      const [name, amount, year] = feeItem.value.split('|').map((item) => item.trim());
      return !allFees.some((allFee) => allFee.name === name);
    });
  }

  const setModal = useContext(ModalContext);

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const transformedFees = formDataFees.orFees.map((fee) => {
      const [name, amount, year] = fee.split('|').map((item) => item.trim());

      if (moduleType === 'BPLS') {
        return { 
          name, 
          amount, 
          year 
        };
      }

      return { 
        name, 
        amount 
      };
    });

    const newFormData = {
      ...formData,
      fees: transformedFees,
      date: moment(formData.date).format('YYYY-MM-DD'),
    };

    createOfficialReceipt(newFormData, ({ data }) => {
      setModal({ isOpen: false });
      getOfficialReceipts();
      if (triggerParentEffect) {
        triggerParentEffect();
      }
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleSelectChange = (e, key) => {
    if (!e) {
      setFormDataFees((prev) => ({
        ...prev,
        [key]: [],
      }));
      return;
    }

    if (key === 'orFees' && Array.isArray(e)) {
      setFormDataFees((prev) => ({
        ...prev,
        [key]: e.map((x) => x.value),
      }));
      return;
    }
  };

  const getNotificationEventValues = () => {
    return (formDataFees.orFees || []).map((val) => {
      const matchingOption = feesItems.find((item) => item.value === val);
      return matchingOption || { label: val, value: val };
    });
  };

  const getAmountFromFee = (feeString) => {
    // Return 0 if feeString is null or undefined
    if (feeString == null) {
      return 0;
    }

    try {
      const [, amount] = feeString.split('|').map((item) => item?.trim() || '');
      // Convert to number and handle NaN case
      const parsedAmount = parseFloat(amount);
      // Return the parsed amount if it's a valid number (including 0), otherwise return 0
      return !isNaN(parsedAmount) ? parsedAmount : 0;
    } catch (error) {
      // Return 0 if any error occurs during parsing
      return 0;
    }
  };

  const totalAmount = (formDataFees?.orFees || []).reduce((sum, fee) => {
    return sum + getAmountFromFee(fee);
  }, 0);

  const handleSelectAll = () => {
    const allFeeValues = feesItems.map((item) => item.value);
    setFormDataFees((prev) => ({
      ...prev,
      orFees: allFeeValues,
    }));
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'number', label: 'OR Number:' },
              { required: true, placeholder: 'Input OR Number' }
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="date" className="form-label">
              Date:{' '}
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date')}
              value={_.get(formData, 'date') || ''}
            />
          </div>

          <div className="col-12 form-group">
            <label htmlFor="orFees" className="form-label">
              Fees:{' '}
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>

            <div className="d-flex align-items-center" style={{ gap: '.5em' }}>
              <Select
                value={getNotificationEventValues()}
                isMulti
                closeMenuOnSelect={false}
                name="orFees"
                options={feesItems}
                className="basic-multi-select flex-grow-1"
                classNamePrefix="select"
                placeholder="Fees..."
                onChange={(e) => handleSelectChange(e, 'orFees')}
                styles={{
                  multiValue: (provided) => ({
                    ...provided,
                    maxWidth: '250px',
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    maxWidth: '250px',
                  }),
                }}
              />
              <button
                className="btn btn-sm btn-primary h-100 flex-shrink-0"
                type="button"
                onClick={handleSelectAll}
              >
                Select All
              </button>
            </div>

            <small className="text-muted">
              Total Amount Added:{' '}
              <span
                className={`${
                  totalAmount <= 0 ? 'text-danger' : 'text-success'
                } font-weight-bold`}
              >
                ₱ {numberFormat(totalAmount || 0)}
              </span>
            </small>
          </div>

          <div className="col-12 form-group">
            <label htmlFor="remarks" className="form-label">
              Remarks:{' '}
              {/* <span className="text-danger">
                <i>Required</i>
              </span> */}
            </label>

            <textarea
              className="form-control"
              id="remarks"
              rows="3"
              value={_.get(formData, 'remarks', '')}
              onChange={handleOnChangeDate('remarks')}
              placeholder="Input Remarks"
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || totalAmount <= 0}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createOfficialReceipt: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  getOfficialReceipts: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  moduleType: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  officialReceiptList: _.get(api, `${c.GET_OFFICIAL_RECEIPTS}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_OFFICIAL_RECEIPT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
